import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import SearchBar from "material-ui-search-bar";
import { fetchWithToken } from "../../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
  },
  { id: "lastName", numeric: true, disablePadding: false, label: "Last Name" },
  { id: "email", numeric: true, disablePadding: false, label: "Email" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    searchedObj,
    setPage,
    setSearched,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ fontSize: ".9vw", padding: "5px" }}
          >
            <div class="input-group" style={{ justifyContent: "center" }}>
              {headCell.id == "firstName" && (
                <SearchBar
                  placeholder="First Name"
                  value={
                    searchedObj.domain === "firstName"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "firstName")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "lastName" && (
                <SearchBar
                  placeholder="Last Name"
                  value={
                    searchedObj.domain === "lastName"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "lastName")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "email" && (
                <SearchBar
                  placeholder="Email"
                  value={
                    searchedObj.domain === "email" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "email")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </div>
          </TableCell>
        ))}
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: ".9vw", padding: "5px", width: "150px" }}
        >
          Select
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();

  return (
    <Toolbar className={clsx(classes.root)}>
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Users
      </Typography>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const AdminMailingListUsersTable = (props) => {
  const { users, sendAlert, setDataObj } = props;
  const classes = useStyles();
  const [rows, setRows] = useState(users);
  const [order, setOrder] = useState("asc");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [orderBy, setOrderBy] = useState("firstName");
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, users.length - page * rowsPerPage);

  const handleFilter = () => {
    const filteredRows = rows.filter((row) => {
      if (searchedObj.domain === "firstName" && row.firstName != null) {
        return row.firstName
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "lastName" && row.lastName != null) {
        return row.lastName
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "email" && row.email != null) {
        return row.email
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      } else return rows;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const addUserHandler = (row) => {
    //Create and add new entries for each role using usrId
    fetchWithToken(`/api/AdminMailingList/AddUser/`, "POST", {
      userId: row.userId,
    }).then((data) => {
      if (!data.ok) {
        if (data.status == 409) {
          sendAlert("User Already On Admin Mailing List", "warning");
        }
      } else {
        setDataObj((prev) => {
          return {
            ...prev,
            mailList: [
              ...prev.mailList,
              {
                gmid: row.gmid,
                userId: row.userId,
                firstName: row.firstName,
                lastName: row.lastName,
                fullName: row.firstName + " " + row.lastName,
                telephone: row.telephone,
                email: row.email,
              },
            ],
          };
        });
        sendAlert("User Added", "success");
      }
    });
  };

  return (
    <>
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            setSearched={setSearched}
            searchedObj={searchedObj}
            setPage={setPage}
            rowCount={users.length}
          />
          <TableBody>
            {stableSort(handleFilter(), getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    role="checkbox"
                    tabIndex={-1}
                    key={row.name}
                    style={{
                      height: "60px",
                      background: index % 2 ? "#f8f8f8" : "white",
                    }}
                  >
                    <TableCell align="center" style={{ width: "30%" }}>
                      {row.firstName}
                    </TableCell>
                    <TableCell align="center" style={{ width: "30%" }}>
                      {row.lastName}
                    </TableCell>
                    <TableCell align="left" style={{ width: "30%" }}>
                      {row.email}
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.smallColumn}
                      style={{ width: "10%" }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => addUserHandler(row)}
                      >
                        <CheckIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: users.length > rowsPerPage ? 60 * emptyRows : 60,
                }}
              >
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={users.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default AdminMailingListUsersTable;
